<template>
  <section class="adminSectionActivity">
    <div class="adminContent">
      <h2>體驗活動</h2>
      <div class="d-flex flex-row-reverse">
        <div class="p-2">
          <router-link
            :to="{name:'activityEdit',params:{index:'addData'}}"
            class="txt4"
            style="text-decoration:none;"
          >
            <button type="button" class="btn">
              <i class="material-icons">add</i>
            </button>
          </router-link>
        </div>
      </div>
      <table class="table table-hover">
        <thead>
          <tr>
            <th style="width: 10%;">NO</th>
            <th style="width: 40%;">Title</th>
            <th style="width: 30%;">Link</th>
            <th style="width: 20%;">Option</th>
          </tr>
        </thead>
        <tbody v-for="(vendorActivity, index) in configBlogData" :key="configBlogData[index].key">
          <tr
            v-if=" (index+1) > ((currentPage-1) * pageSize) && (index+1) <= ((currentPage) * pageSize)"
          >
            <td>{{index+1}}</td>
            <td>{{vendorActivity.doc.activityTitle}}</td>
            <td>
              <router-link
                :to="vendorActivity.doc.routeName"
                class="txt4"
                style="text-decoration:none;"
              >{{vendorActivity.doc.routeName}}</router-link>
            </td>
            <td>
              <router-link
                :to="{name:'activityEdit',params:{index:vendorActivity.key}}"
                class="txt4"
                style="text-decoration:none;"
              >
                <button type="submit" class="btn">
                  <i class="material-icons edit">edit</i>
                </button>
              </router-link>
              <button type="button" class="btn">
                <i
                  class="material-icons delete"
                  @click="deleteData(vendorActivity.key, index)"
                >delete</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination flex-c-m flex-w p-l-15 p-r-15 m-t-24 m-b-50">
        <el-pagination
          layout="pager"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import { constants, close } from "fs";
export default {
  name: "Activity",
  data() {
    return {
      configBlogData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1
    };
  },
  created() {
    let self = this;
    const p = new Promise((resolve, reject) => {
      const readVendorInfo = firebaseDB.ref("activities");
      readVendorInfo
        .orderByChild("vendorActivityNum")
        .on("value", function(snapshot) {
          let datas = [];
          snapshot.forEach(function(childSnapshot) {
            datas.push({ doc: childSnapshot.val(), key: childSnapshot.key });
          });
          if (datas.length != self.configBlogData.length) {
            self.configBlogData = datas;
            self.total = self.configBlogData.length;
          }
        });
      resolve();
    })
      .then()
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    async deleteData(router, index) {
      let res = confirm("確定要刪除資料?");
      if (res == true) {
        let name = "activities/" + router;
        const result = await firebaseDB
          .ref(name)
          .remove()
          .then(() => {
            if (this.total <= (this.currentPage - 1) * this.pageSize) {
              this.currentPage--;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      window.scrollTo(0, 300);
    }
  }
};
</script>

<style scoped>
/* ---------------------------------------------------
        adminContent STYLE
    ----------------------------------------------------- */

.adminContent {
  width: calc(100% - 250px);
  min-height: calc(100% - 70px);
  transition: all 0.3s;
  position: relative;
  top: 70px;
  right: 0;
  padding: 30px 25px;
  margin-left: 250px;
  background-color: #ebebeb;
}

.adminContent.active {
  width: 100%;
  margin-left: 0;
}

.adminContent td {
  vertical-align: middle;
}

.adminContent button:focus {
  box-shadow: 0 0 0 !important;
}

.adminContent button:active {
  box-shadow: 0 0 0 !important;
}

.adminContent .material-icons {
  line-height: unset;
}

.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 35px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 13px;
  color: #808080;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  margin: 6px;
  text-align: center;
}
.el-pager li.active {
  background-color: #333333;
  color: white;
}
.pagination {
  display: flex;
}
.pagination >>> .el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 35px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 13px;
  color: #808080;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  margin: 6px;
  text-align: center;
}
.pagination >>> .el-pager li.active {
  background-color: #333333;
  color: white;
}

/* ---------------------------------------------------
        MEDIAQUERIES
    ----------------------------------------------------- */

@media (max-width: 768px) {
  .adminContent {
    width: 100%;
  }
  .adminContent.active {
    width: calc(100% - 250px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin-manage/Activity.vue